export function Reference({ text }: { text: string | null | undefined }) {
    if (!text) return null
    if (text.length === 0) return null
    return <p className="mt-2 text-sm text-gray-500 italic">{text}</p>
}
